import { parsePositiveNumber } from '../../utils/number'

export const extractDefaultVehiculeOptions = data => {
  return data?.vehicles.providers
}

export const extractTransportModes = data => {
  return data?.transport_modes
}

export const extractDefaultFuelPrices = data => {
  const fuelPrices = data?.fuel_prices ?? {}
  return Object.entries(fuelPrices).reduce((acc, entry) => {
    const [key, price] = entry
    acc[key] = parsePositiveNumber(price, 3)
    return acc
  }, {})
}
